import request from '../utils/request'

// 获取数据报表
export function getDataReport(params) {
  return request({
    url: '/data-report',
    method: 'get',
    params
  })
}

